import NextSection from "@components/About/NextSection";
import React from "react";
import cx from "classnames";
import styles from "./Jobs.module.scss";
import JobItem from "./JobItem";

import { careerPage } from "@utils/helper";
import { usePageContext } from "@providers/PageProvider";
import _ from "lodash";

export default function Jobs() {
  const { pageData } = usePageContext();
  const works = careerPage.formatWorks(pageData);
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <NextSection>{_.get(works, "title")}</NextSection>
      <div
        className={cx(styles.description)}
        dangerouslySetInnerHTML={{
          __html: _.get(works, "description"),
        }}
      ></div>
      <div className={cx(styles.listJobs)}>
        {_.map(_.get(works, "careers", []), (job: any, index) => (
          <JobItem key={index} data={job} />
        ))}
      </div>
    </div>
  );
}
